import React from "react";
import Mic from "../../../assets/Icons/mic.svg";
import MicMute from "../../../assets/Icons/mic-mute.svg";
import Camera from "../../../assets/Icons/camera.svg";
import CameraOff from "../../../assets/Icons/camera-off.svg";

export default function Participants({
  streams,
  me,
  localStream,
  isMuted,
  isVideoTrack,
  isGroupCall,
  isVideoCall,
  muteStream,
  unmuteStream,
  turnOnVideo,
  turnOffVideo,
  maximizeUserVideo,
}) {
  return (
    <div className="p-2">

      {/* Current User */}
      <div
        className="d-flex justify-content-between align-items-center border rounded p-2 mb-2 bg-white participant-item"
        key={me?._id}
      >
        <div
          className="d-flex align-items-center cursor-pointer"
          onClick={() => maximizeUserVideo(localStream, me)}
        >
          {me?.imageSrc && me?.imageSrc !== "" ? (
            <img
              src={me.imageSrc}
              className="rounded-circle me-2"
              style={{ width: "32px", height: "32px", objectFit: "cover" }}
              alt="user"
            />
          ) : (
            <div
              className="rounded-circle bg-primary text-white d-flex justify-content-center align-items-center me-2"
              style={{ width: "32px", height: "32px", fontSize: "14px" }}
            >
              {me?.contactName?.first?.charAt(0)}
            </div>
          )}

          <span className="fw-semibold">You</span>
        </div>

        <div className="d-flex align-items-center gap-2">
          {isMuted ? (
            <img
              src={MicMute}
              alt="mic-mute"
              onClick={unmuteStream}
              className="cursor-pointer"
              style={{ width: "18px" }}
            />
          ) : (
            <img
              src={Mic}
              alt="mic"
              onClick={muteStream}
              className="cursor-pointer"
              style={{ width: "18px" }}
            />
          )}

          {!isGroupCall &&
            (!isVideoTrack ? (
              <img
                src={CameraOff}
                alt="camera-off"
                onClick={turnOnVideo}
                className="cursor-pointer"
                style={{ width: "18px" }}
              />
            ) : (
              <img
                src={Camera}
                alt="camera"
                onClick={turnOffVideo}
                className="cursor-pointer"
                style={{ width: "18px" }}
              />
            ))}

          {isGroupCall &&
            isVideoCall &&
            (!isVideoTrack ? (
              <img
                src={CameraOff}
                alt="camera-off"
                onClick={turnOnVideo}
                className="cursor-pointer"
                style={{ width: "18px" }}
              />
            ) : (
              <img
                src={Camera}
                alt="camera"
                onClick={turnOffVideo}
                className="cursor-pointer"
                style={{ width: "18px" }}
              />
            ))}
        </div>
      </div>

      {/* Other Participants */}
      {streams.map((obj) => {
        const { user } = obj;

        return (
          <div
             className="d-flex align-items-center border rounded p-2 mb-2 bg-white cursor-pointer participant-item"
            key={user?._id}
            onClick={() => maximizeUserVideo(obj.stream, user)}
          >
            {user?.imageSrc && user?.imageSrc !== "" ? (
              <img
                src={user.imageSrc}
                className="rounded-circle me-2"
                style={{ width: "32px", height: "32px", objectFit: "cover" }}
                alt="user"
              />
            ) : (
              <div
                className="rounded-circle bg-secondary text-white d-flex justify-content-center align-items-center me-2"
                style={{ width: "32px", height: "32px", fontSize: "14px" }}
              >
                {user?.contactName?.first?.charAt(0)}
              </div>
            )}

            <span className="fw-semibold">
              {user?.contactName?.first + " " + user?.contactName?.last}
            </span>
          </div>
        );
      })}
    </div>
  );
}